import { render, staticRenderFns } from "./CardManager.vue?vue&type=template&id=55411bbd&scoped=true"
import script from "./CardManager.vue?vue&type=script&lang=js"
export * from "./CardManager.vue?vue&type=script&lang=js"
import style0 from "./CardManager.vue?vue&type=style&index=0&id=55411bbd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55411bbd",
  null
  
)

export default component.exports